module.exports = __webpack_public_path__ + "static/media/pink-co.6c3df71f.png";